/* istanbul ignore file */
import { Box, Paper, Typography } from '@mui/material';
import {
  ChartsTooltipContainer,
  ChartsTooltipContainerProps,
  useAxesTooltip,
} from '@mui/x-charts-pro';
import { useChartsHighlightContext } from 'components/charts/inc-charts.context';
import SeriesItem from './series-item.component';

const SingleItemTooltip = ({ trigger }: ChartsTooltipContainerProps) => {
  if (trigger === 'none') return null;

  return (
    <ChartsTooltipContainer>
      <CustomAxisTooltip />
    </ChartsTooltipContainer>
  );
};

const CustomAxisTooltip = () => {
  const tooltipData = useAxesTooltip();
  const { isHighlighted } = useChartsHighlightContext();

  // Only supports one axis for now
  const firstAxisData = tooltipData?.[0];

  if (!firstAxisData) {
    return null;
  }

  const singularItem = firstAxisData.seriesItems.find(seriesItem =>
    isHighlighted(seriesItem.seriesId),
  );

  if (!singularItem) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        m: 1,
        border: 'solid',
        borderWidth: 2,
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Box display="grid">
        <Box
          sx={{
            borderBottom: 'solid',
            borderWidth: 2,
            borderColor: 'divider',
            px: 1.5,
            py: 0.75,
          }}
        >
          <Typography>{firstAxisData.axisFormattedValue}</Typography>
        </Box>
        <Box display="grid" rowGap={0.5} px={1.5} py={0.75}>
          <SeriesItem
            seriesItem={singularItem}
            key={singularItem.seriesId}
            highlighted={isHighlighted(singularItem.seriesId)}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default SingleItemTooltip;
